const QrCode = ({ qrCode, maxHeight }) => {

    return (
        <div className='bg-white rounded-lg inline-block]'> 
            {qrCode ? (
                <>
                    <img 
                        src={qrCode} 
                        alt="QR Code" 
                        style={maxHeight ? { maxHeight, height: 'auto', width: 'auto', borderRadius: '0.5rem' } : { borderRadius: '0.5rem' }}
                        className="overflow-hidden"
                    />
                </>
            ) : (
                <p>Loading QR code...</p>
            )}
        </div>
    );
};

export default QrCode;
